import './contact.scss';

/**
 * The enquiry form is rendered once per page inside #contact-lightbox, so a
 * "Küsi hinda" link on a price list row has to say which unit it belongs to as
 * it opens the form.
 *
 * Hidden Gravity Forms fields carry no CSS class of their own, but the theme
 * already stamps them with their parameter name (see the `hidden` case in
 * gotoAndCore\Plugins\GravityForms), so the field named `apartment` is what we
 * fill in. With no such field in the form, the form simply opens as before.
 */
const APARTMENT_TRIGGER: string = '[data-price-enquiry]';
const APARTMENT_FIELD: string = '[data-name="apartment"]';

$(document).on('click', APARTMENT_TRIGGER, (event: JQuery.TriggeredEvent): void => {
    const apartment: string = `${$(event.currentTarget).data('price-enquiry') || ''}`;

    $('#contact-lightbox').find(APARTMENT_FIELD).val(apartment);
});
